export const API_KEY = "AIzaSyDaokbtQO7IsYV0XwXuUV4Wdd5HDOt9LMY";

export default API_KEY;